export default "__VITE_ASSET__983b45b4__"